import React from "react";
import Tournaments from "./Tournaments";
import Summary from "./Summary";
import Articles from "./Articles";
import { ComponentContainer } from "./ComponentContainer";
import Head from "next/head";
interface Props {}

export const LandingComponent = (props: Props) => {
  return (
    <>
      <Head>
        <title>GolfChamps | Home</title>
      </Head>
      <ComponentContainer>
        <div className="grid grid-cols-2 gap-x-[32px] gap-y-[40px]">
          <div className="col-span-2">
            <Summary />
          </div>
          <div className="col-span-2 md:col-span-1">
            <Tournaments />
          </div>
          <div className="col-span-2 md:col-span-1">
            <Articles />
          </div>
          <div className="col-span-2 md:col-span-1"></div>
        </div>
      </ComponentContainer>
    </>
  );
};
